export default __webpack_public_path__ + "static/fa-light-300-48d5b0cddbcd5e71838820b1a246e24d.woff2";